const metaMap = {
    "/": {
        title: "Home | Anvil & Ember Metalworks",
        description: "Handcrafted silver, copper, and brass jewelry by Anvil & Ember Metalworks. Timeless designs forged with skill and passion.",
    },
    "/shop": {
        title: "Shop | Anvil & Ember Metalworks",
        description: "Browse unique handcrafted pieces available for purchase.",
    },
    "/gallery": {
        title: "Gallery | Anvil & Ember Metalworks",
        description: "View a curated gallery of artisan jewelry designs.",
    },
    "/about": {
        title: "About | Anvil & Ember Metalworks",
        description: "Meet Adam Boyd, metalsmith and creator of Anvil & Ember Metalworks.",
    },
    "/contact": {
        title: "Contact | Anvil & Ember Metalworks",
        description: "Get in touch for custom orders or questions.",
    },
    "/code": {
        title: "Code | Anvil & Ember Metalworks",
        description: "Explore the code behind the Anvil & Ember Metalworks website and a few coding practice projects.",
    },
};

export default metaMap;